export const application = 'academy-preprod';

export const apiURL = '/bright/api'; // config preprod backend url

export const vimeoURL = 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com';
